import { where, documentId } from 'firebase/firestore';
import {
  fetchByTable,
  addDataToTable,
  updateDataById,
  deleteDocById,
  delay,
} from '../utils';
import { fetchUserById, fetchUserByEmail } from '../profile/api';

export const fetchShifts = async setLoading =>
  fetchByTable({ tableName: 'shifts', orderByField: 'startDate', setLoading });

export const fetchShiftsByUser = async (userId, setLoading) =>
  fetchByTable({
    tableName: 'shifts',
    whereCondition: where('userId', '==', userId),
    orderByField: 'startDate',
    setLoading,
  });

export const fetchShiftById = async (id, setLoading) =>
  fetchByTable({
    tableName: 'shifts',
    whereCondition: where(documentId(), '==', id),
    setLoading,
  });

export const fetchShiftsByPlaceId = async (id, setLoading) =>
  fetchByTable({
    tableName: 'shifts',
    whereCondition: where('placeId', '==', id),
    setLoading,
  });

export const addShift = async (shift, setLoading) =>
  addDataToTable({ tableName: 'shifts', data: shift, setLoading });

export const updateShift = async (id, data, setLoading) =>
  updateDataById({ id, tableName: 'shifts', data, setLoading });

export const addGame = async (userId, setLoading) =>
  fetchUserById(userId, setLoading).then(values => {
    const u = values[0];
    updateDataById({
      id: u.id,
      tableName: 'users',
      data: { games: u.games > 0 ? u.games + 1 : 1 },
      setLoading,
    });
  });

export const addOwnerGame = async (email, setLoading) => {
  fetchUserByEmail(email, setLoading).then(values => {
    const u = values[0];
    updateDataById({
      id: u.id,
      tableName: 'users',
      data: { createdGames: u.createdGames > 0 ? u.createdGames + 1 : 1 },
      setLoading,
    });
  });
};

export const addFriend = async (userId, friends, playerMail, setLoading) =>
  updateDataById({
    id: userId,
    tableName: 'users',
    data: { friendsIds: [...friends, playerMail] },
    setLoading,
  });

export const removeShift = async (id, setLoading) =>
  deleteDocById({ tableName: 'shifts', id, setLoading });

export const closeShift = async (id, close, setLoading) =>
  updateDataById({
    id,
    tableName: 'shifts',
    data: { isClosed: close },
    setLoading,
  });

export const removeStatsByShift = async (id, setLoading) => {
  setLoading(true);
  try {
    fetchByTable({
      tableName: 'stats',
      whereCondition: where('shiftId', '==', id),
    }).then(values => {
      values.forEach(value => {
        deleteDocById({ tableName: 'stats', id: value.id });
      });
    });
    await delay(2000);
  } catch (e) {
    console.log(e);
  } finally {
    setLoading(false);
  }
};

export const addStat = async (stat, setLoading) =>
  addDataToTable({ tableName: 'stats', data: stat, setLoading });
